// Port of api/fuel/app/classes/model/game/subdomain.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_subdomain',
	prefix: '',
	key: 'game_subdomain_id',
	fields: {
		game_subdomain_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		subdomain_id: Model.SCHEMA_NUMBER
	}
})
